module.exports = __webpack_public_path__ + "static/logo_darkblue_transparent-3a80e2504fe730aeee2747bd13301850.png";